<div class="dialog">
  <div class="mat-display-3" style="font-weight: 500;">
    {{type == 'add' ? "Add User" : "Edit User"}}
  </div>
  <mat-dialog-content class="content">

    <!-- user details -->
    <form [formGroup]="addPatientFormGroup">
      <div class="section">
        <div class="sub-section" style="padding-bottom: 10px;">
          <span class="mat-subheading-2 section-label">User details</span>
        </div>
        <div class="sub-section">
          <mat-form-field appearance="outline" class="form-fields" style="width: 48%;">
            <mat-label>Given name </mat-label>
            <input matInput #firstName required formControlName="firstName" [maxlength]="50" appTrimOnBlur (keydown.space)="$event.preventDefault()"(keypress)="keyPressChar($event)" (input)="capitalizeFirstLetter('firstName')">
            <mat-hint align="end">{{firstName.value.length}} / 50</mat-hint>
            <mat-hint class="error-hint" *ngIf="(addPatientFormGroup.controls['firstName'].touched && addPatientFormGroup.controls['firstName'].hasError('required'))" >
              Please enter at least 3 characters
             </mat-hint>
             <mat-hint class="error-hint"  *ngIf="((addPatientFormGroup.controls['firstName'].hasError('pattern') || addPatientFormGroup.controls['firstName'].hasError('minlength')))">Please enter at least 3 characters
             </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-fields" style="width: 48%;">
            <mat-label>Family name </mat-label>
            <input matInput formControlName="lastName" #lastName [maxlength]="50" appTrimOnBlur (keydown.space)="$event.preventDefault()"(keypress)="keyPressChar($event)" (input)="capitalizeFirstLetter('lastName')">
            <mat-hint align="end">{{lastName.value.length}} / 50</mat-hint>
            <mat-hint class="error-hint"  *ngIf="(addPatientFormGroup.controls['lastName'].hasError('pattern'))">Please enter only alphabets
            </mat-hint>
          </mat-form-field>
        </div>

        <div class="sub-section">
          <mat-form-field appearance="outline" #outlineFieldRef class="form-fields mobile-input" style="width: 48%;" >
            <mat-label>Mobile Number </mat-label>
            <span matPrefix >+678 &nbsp;</span>
            <input matInput required formControlName="mobileNumber" #mobileNumber [maxlength]="10" appTrimOnBlur
            (focus)="outlineFieldRef.updateOutlineGap()" (keydown.space)="$event.preventDefault()" (keypress)="keyPressNumber($event)">
            <mat-hint align="end">{{mobileNumber.value.length}} / 10</mat-hint>
            <mat-hint class="error-hint" *ngIf="(addPatientFormGroup.controls['mobileNumber'].touched && addPatientFormGroup.controls['mobileNumber'].hasError('required'))" >
              Enter a valid mobile number
             </mat-hint>
             <mat-hint class="error-hint"  *ngIf="((addPatientFormGroup.controls['mobileNumber'].hasError('pattern') ||addPatientFormGroup.controls['mobileNumber'].hasError('minlength')))">Enter a valid mobile number
            </mat-hint>
             
          </mat-form-field>
        </div>
      </div>

      <!-- Organization details -->
      <div class="section">
        <div class="sub-section" style="padding-bottom: 10px;">
          <span class="mat-subheading-2 section-label">Organization details</span>
        </div>
        <div class="sub-section">
          <mat-form-field appearance="outline" class="form-fields">
            <mat-label>Organization</mat-label>
            <mat-select name="organization" required formControlName="orgId">
              <mat-option *ngFor="let org of organizationsList" [value]="org.id">{{org.name}}</mat-option>
            </mat-select>
            <mat-hint class="error-hint" *ngIf="(addPatientFormGroup.controls['orgId'].touched && addPatientFormGroup.controls['orgId'].hasError('required'))" >
              Please select an organization
             </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-fields">
            <mat-label>Role</mat-label>
            <mat-select name="role" required formControlName="roleId">
              <mat-option *ngFor="let role of rolesList" [value]="role.id">{{role.value}}</mat-option>
            </mat-select>
            <mat-hint class="error-hint" *ngIf="(addPatientFormGroup.controls['roleId'].touched && addPatientFormGroup.controls['roleId'].hasError('required'))" >
              Please select a role
             </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="section" *ngIf="type == 'add'">
        <div class="sub-section" style="padding-bottom: 10px;">
          <span class="mat-subheading-2 section-label">Account configuration</span>
        </div>
        <div class="sub-section">
          <mat-slide-toggle formControlName="isActive" color="primary" (change)="toggleChanged($event)" style="padding: 10px 0 10px 0">
             <span>{{this.userStatusText}}</span>
          </mat-slide-toggle>
        </div>
      </div>
    </form>


  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="onCancel()" mat-dialog-close>CANCEL</button>
    <button mat-button color="primary" (click)="onSave()" [disabled]="addPatientFormGroup.invalid">SAVE</button>
  </mat-dialog-actions>
</div>